import React, { useCallback, useEffect, useState } from 'react';
import * as SettingComponents from './settings';
import styles from '../Dashboards.module.css';

const ExtensionPanelConfiguration = ({ panel, updatePanel }) => {
  const [extensionSettings, setExtensionSettings] = useState(null);

  const loadSettings = useCallback(async () => {
    setExtensionSettings(null);
    const ahaPanel = window.aha.getPanel(
      panel.extensionIdentifier,
      panel.exportName
    );

    const settings = (await ahaPanel.trigger({ action: 'settings' })) || [];
    setExtensionSettings(settings);
  }, [panel.extensionIdentifier, panel.exportName]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  return (
    <div className={styles.PanelConfigurationSection}>
      <h2 className={styles.PanelConfigurationSectionHeader}>
        Extension settings
      </h2>

      {extensionSettings ? (
        extensionSettings.map(setting => {
          const InputComponent = SettingComponents[setting.type];
          if (!InputComponent) {
            console.error(`Invalid setting type: ${setting.type}`);
            return null;
          }

          return (
            <div key={setting.key} className={styles.PanelConfigurationLayout}>
              <InputComponent
                className={styles.PanelConfigurationSectionSubtitle}
                title={setting.title}
                panel={panel}
                setting={setting}
                updatePanel={updatePanel}
              />
            </div>
          );
        })
      ) : (
        <div>
          <aha-spinner /> Loading settings…
        </div>
      )}
    </div>
  );
};

export default ExtensionPanelConfiguration;
